import type { RouteObject } from 'react-router'

import { OrganizationPage } from '@/features/organization/OrganizationPage'

export const routes: RouteObject[] = [{ path: 'organization', element: <OrganizationPage /> }]
